import React, { useEffect, useId, useState } from "react";
import { Link } from "react-router-dom";
import { getGroupsUserId } from "../../Components/Settings/Helpingfiles/KeycloakHelpmethods";

const DesigneraddRole = () => {
 

  
  // useEffect(()=>
  // {
  //  const fetchroles=async ()=>
  //  {

  //   const roleIDdata=await getGroupsUserId();
  //  roleIDdata[1].forEach(element => {
  //   if(element.name=="formsflow-designer")
  //   {
  //     setDesignerId(element.id)
  //   }
    
  //  });
   
  //  }
  //  fetchroles();
  // },[])

  useEffect(() => {


    nextapicall();
  }, []);

  const nextapicall = async () => {
    let response = await fetch(
      `http://localhost:8080/auth/admin/realms/forms-flow-ai/users?briefRepresentation=true&first=0&max=50`,
      {
        method: "GET", // *GET, POST, PUT, DELETE, etc.
        Accept: "application/json",

        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",
          Host: "localhost:8080",
          "Sec-Fetch-Mode": "cors",
          "Sec-Fetch-Site": "same-site",

          //  "Remote Address": "[::1]:8080",

          Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url

        // body data type must match "Content-Type" header
      }
    );

    let data = await response.json();

    let found = data.find((data) => {
      return (
        data.email === JSON.parse(localStorage.getItem("UserDetails")).email
      );
    });

    addroletouser(found.id);
  };

  const addroletouser = async (userid) => {
    console.log("designerfile")
    let designerId;

    const roleIDdata=await getGroupsUserId();
    console.log(roleIDdata[1])
    roleIDdata[1].subGroups.forEach(element => {
     if(element.name=="formsflow-designer")
     {
      designerId=element.id;
     }
     
    });
    const payload = {
      realm: "forms-flow-ai",
      userId: userid,
      groupId: designerId
    };

    let response = await fetch(
      `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${userid}/groups/${designerId}`,
      {
        method: "PUT", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        Origin: "http://localhost:8080",
        headers: {
          "Content-Type": "application/json",
          Host: "localhost:8080",
          Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(payload), // body data type must match "Content-Type" header
      }
    );


    let data = await response.json().then(()=>
    {
      alert("All roles has been assigned successfully!!!")
    }).catch((err)=>alert(err))
    




    
  };

  return (
  <></>
  );
};

export default DesigneraddRole;
